var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2160,
    height: 291,
    viewBox: "0 0 2160 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 460,
    height: 291
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H-70V322H390V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7002 274.338V152.463L46.9377 143.461V127.88H82.7202V288.88H42.7002V274.338Z",
    fill: "url(#paint0_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 460,
    height: 291
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H-70V322H390V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.309 177.035V148.58H107.207L102.932 150.838H86.9434V164.84H77.8901V322H102.932H132.86V177.035H124.309Z",
    fill: "url(#paint1_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 460,
    height: 322
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H-70V322H390V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.362 304.52L289.237 118.475H291.331V116.401H297.681V102.292H289.29V100.632H290.197V96.0679H291.105V92.7481H289.29V66.1909H291.105V62.0412H289.064V50.1465C289.064 49.8291 288.782 49.5715 288.435 49.5715H288.156V41.7962C288.156 41.5409 288.019 41.3168 287.809 41.1775V35.9063C287.809 35.5917 287.53 35.3364 287.186 35.3364H287.023V27.6001H286.569V35.3364H286.406C286.062 35.3364 285.783 35.5917 285.783 35.9063V41.1775C285.574 41.3168 285.436 41.5409 285.436 41.7962V49.5715H285.157C284.81 49.5715 284.529 49.8291 284.529 50.1465V62.0412H282.488V66.1909H284.302V92.7481H282.488V96.0679H283.395V100.632H284.302V102.292H275.911V116.401H282.261V118.475H283.991L275.23 304.52H298.362Z",
    fill: "url(#paint2_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 460,
    height: 322
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H-70V322H390V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.841 189.076V159.997H388.93L391.702 162.305H402.069V176.614H407.94V318.78H391.702H372.296V189.076H377.841Z",
    fill: "url(#paint3_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 460,
    height: 322
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H-70V322H390V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.698 190.9V212.18L290.18 214.544V309.12H340.78V216.908H335.359V205.086H329.938V190.9H294.698Z",
    fill: "url(#paint4_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -70,
    y: 0,
    width: 460,
    height: 322
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M390 0H-70V322H390V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.26 206.08V248.86H362.411V141.197H359.117V89.3169H353.353V78.6118H332.766L326.178 81.0825V90.9642H318.767V107.434H312.179V294.86H283.28V168.695L281.056 163.507H274.385V144.235H264.749C246.219 147.2 238.065 163.507 238.065 163.507V261.74H215.312V229.263C212.655 228.843 200.893 229.263 200.893 229.263V223.808C160.294 217.932 129.18 226.325 129.18 226.325V276.46H96.52V199.695H91.5791V190.679H86.6383V179.86H54.5224V196.089L50.405 197.892V254.84L38.9353 266.8H27.06V156.217L20.16 153.056V146.339L-5.60002 143.968L-26.4233 147.92V156.217V156.298L-34.12 161.354V275.54H-52.06V192.28L-63.79 179.86H-75.52V322H-55.28H-52.06H-34.12H-17.1H22.46H27.06H50.405H68.46H91.92H96.52H129.18H137.46H215.312H246.345H256.6H286.96H291.56H312.179H342.62H362.411H378.04H398.74H434.16V194.12H410.398L381.26 206.08Z",
    fill: "url(#paint5_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 0,
    width: 460,
    height: 322
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M850 0H390V322H850V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.46 145.123L427.01 145.124L427.007 137.534L423.327 137.536L423.319 118.216L414.77 118.219L414.77 118.21L414.418 93.8325L414.325 87.3999H415.99V86.9399H414.319L414.066 69.4548H413.146L412.894 86.9399H411.39V87.3999H412.887L412.794 93.8325L412.443 118.21L412.442 118.22L403.769 118.224L403.777 137.544L400.097 137.545L400.1 145.135L396.65 145.137L396.701 322.698L430.482 322V322.453L430.511 322.46L430.46 145.123Z",
    fill: "url(#paint6_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 0,
    width: 460,
    height: 322
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M850 0H390V322H850V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.7 274.338V152.463L506.938 143.461V127.88H542.72V288.88H502.7V274.338Z",
    fill: "url(#paint7_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 0,
    width: 460,
    height: 322
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M850 0H390V322H850V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.309 177.035V148.58H567.207L562.932 150.838H546.943V164.84H537.89V322H562.932H592.86V177.035H584.309Z",
    fill: "url(#paint8_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 0,
    width: 460,
    height: 322
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M850 0H390V322H850V0Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M758.362 304.52L749.237 118.475H751.332V116.401H757.682V102.292H749.291V100.632H750.198V96.0679H751.105V92.7481H749.291V66.1909H751.105V62.0412H749.064V50.1465C749.064 49.8291 748.783 49.5715 748.436 49.5715H748.157V41.7962C748.157 41.5409 748.019 41.3168 747.81 41.1775V35.9063C747.81 35.5917 747.531 35.3364 747.187 35.3364H747.024V27.6001H746.57V35.3364H746.407C746.063 35.3364 745.784 35.5917 745.784 35.9063V41.1775C745.574 41.3168 745.436 41.5409 745.436 41.7962V49.5715H745.158C744.811 49.5715 744.529 49.8291 744.529 50.1465V62.0412H742.488V66.1909H744.303V92.7481H742.488V96.0679H743.395V100.632H744.303V102.292H735.912V116.401H742.262V118.475H743.991L735.23 304.52H758.362Z",
    fill: "url(#paint9_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 0,
    width: 460,
    height: 322
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M850 0H390V322H850V0Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.841 189.076V159.997H848.93L851.703 162.305H862.07V176.614H867.94V318.78H851.703H832.297V189.076H837.841Z",
    fill: "url(#paint10_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 0,
    width: 460,
    height: 322
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M850 0H390V322H850V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.697 190.9V212.18L750.18 214.544V309.12H800.78V216.908H795.358V205.086H789.937V190.9H754.697Z",
    fill: "url(#paint11_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 0,
    width: 460,
    height: 322
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M850 0H390V322H850V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.26 206.08V248.86H822.411V141.197H819.117V89.3169H813.353V78.6118H792.766L786.178 81.0825V90.9642H778.767V107.434H772.179V294.86H743.28V168.695L741.056 163.507H734.385V144.235H724.749C706.219 147.2 698.065 163.507 698.065 163.507V261.74H675.312V229.263C672.655 228.843 660.893 229.263 660.893 229.263V223.808C620.294 217.932 589.18 226.325 589.18 226.325V276.46H556.52V199.695H551.579V190.679H546.638V179.86H514.522V196.089L510.405 197.892V254.84L498.935 266.8H487.06V156.217L480.16 153.056V146.339L454.4 143.968L433.577 147.92V156.217V156.298L425.88 161.354V275.54H407.94V192.28L396.21 179.86H384.48V322H404.72H407.94H425.88H442.9H482.46H487.06H510.405H528.46H551.92H556.52H589.18H597.46H675.312H706.345H716.6H746.96H751.56H772.179H802.62H822.411H838.04H858.74H894.16V194.12H870.398L841.26 206.08Z",
    fill: "url(#paint12_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 850,
    y: 0,
    width: 460,
    height: 322
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 0H850V322H1310V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890.459 145.123L887.009 145.124L887.006 137.534L883.326 137.536L883.319 118.216L874.77 118.219L874.769 118.21L874.417 93.8325L874.324 87.3999H875.99V86.9399H874.318L874.065 69.4548H873.145L872.893 86.9399H871.39V87.3999H872.886L872.794 93.8325L872.442 118.21L872.442 118.22L863.769 118.224L863.776 137.544L860.096 137.545L860.099 145.135L856.649 145.137L856.7 322.698L890.481 322V322.453L890.51 322.46L890.459 145.123Z",
    fill: "url(#paint13_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 850,
    y: 0,
    width: 460,
    height: 322
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 0H850V322H1310V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M962.7 274.338V152.463L966.938 143.461V127.88H1002.72V288.88H962.7V274.338Z",
    fill: "url(#paint14_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 850,
    y: 0,
    width: 460,
    height: 322
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 0H850V322H1310V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044.31 177.035V148.58H1027.21L1022.93 150.838H1006.94V164.84H997.89V322H1022.93H1052.86V177.035H1044.31Z",
    fill: "url(#paint15_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 850,
    y: 0,
    width: 460,
    height: 322
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 0H850V322H1310V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1218.36 304.52L1209.24 118.475H1211.33V116.401H1217.68V102.292H1209.29V100.632H1210.2V96.0679H1211.11V92.7481H1209.29V66.1909H1211.11V62.0412H1209.06V50.1465C1209.06 49.8291 1208.78 49.5715 1208.44 49.5715H1208.16V41.7962C1208.16 41.5409 1208.02 41.3168 1207.81 41.1775V35.9063C1207.81 35.5917 1207.53 35.3364 1207.19 35.3364H1207.02V27.6001H1206.57V35.3364H1206.41C1206.06 35.3364 1205.78 35.5917 1205.78 35.9063V41.1775C1205.57 41.3168 1205.44 41.5409 1205.44 41.7962V49.5715H1205.16C1204.81 49.5715 1204.53 49.8291 1204.53 50.1465V62.0412H1202.49V66.1909H1204.3V92.7481H1202.49V96.0679H1203.4V100.632H1204.3V102.292H1195.91V116.401H1202.26V118.475H1203.99L1195.23 304.52H1218.36Z",
    fill: "url(#paint16_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 850,
    y: 0,
    width: 460,
    height: 322
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 0H850V322H1310V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1297.84 189.076V159.997H1308.93L1311.7 162.305H1322.07V176.614H1327.94V318.78H1311.7H1292.3V189.076H1297.84Z",
    fill: "url(#paint17_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 850,
    y: 0,
    width: 460,
    height: 322
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 0H850V322H1310V0Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1214.7 190.9V212.18L1210.18 214.544V309.12H1260.78V216.908H1255.36V205.086H1249.94V190.9H1214.7Z",
    fill: "url(#paint18_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 850,
    y: 0,
    width: 460,
    height: 322
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1310 0H850V322H1310V0Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1301.26 206.08V248.86H1282.41V141.197H1279.12V89.3169H1273.35V78.6118H1252.77L1246.18 81.0825V90.9642H1238.77V107.434H1232.18V294.86H1203.28V168.695L1201.06 163.507H1194.39V144.235H1184.75C1166.22 147.2 1158.07 163.507 1158.07 163.507V261.74H1135.31V229.263C1132.66 228.843 1120.89 229.263 1120.89 229.263V223.808C1080.29 217.932 1049.18 226.325 1049.18 226.325V276.46H1016.52V199.695H1011.58V190.679H1006.64V179.86H974.523V196.089L970.405 197.892V254.84L958.936 266.8H947.06V156.217L940.16 153.056V146.339L914.4 143.968L893.577 147.92V156.217V156.298L885.88 161.354V275.54H867.94V192.28L856.21 179.86H844.48V322H864.72H867.94H885.88H902.9H942.46H947.06H970.405H988.46H1011.92H1016.52H1049.18H1057.46H1135.31H1166.35H1176.6H1206.96H1211.56H1232.18H1262.62H1282.41H1298.04H1318.74H1354.16V194.12H1330.4L1301.26 206.08Z",
    fill: "url(#paint19_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1310,
    y: 0,
    width: 460,
    height: 322
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1770 0H1310V322H1770V0Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350.46 145.123L1347.01 145.124L1347.01 137.534L1343.33 137.536L1343.32 118.216L1334.77 118.219L1334.77 118.21L1334.42 93.8325L1334.32 87.3999H1335.99V86.9399H1334.32L1334.07 69.4548H1333.15L1332.89 86.9399H1331.39V87.3999H1332.89L1332.79 93.8325L1332.44 118.21L1332.44 118.22L1323.77 118.224L1323.78 137.544L1320.1 137.545L1320.1 145.135L1316.65 145.137L1316.7 322.698L1350.48 322V322.453L1350.51 322.46L1350.46 145.123Z",
    fill: "url(#paint20_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1310,
    y: 0,
    width: 460,
    height: 322
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1770 0H1310V322H1770V0Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1422.7 274.338V152.463L1426.94 143.461V127.88H1462.72V288.88H1422.7V274.338Z",
    fill: "url(#paint21_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1310,
    y: 0,
    width: 460,
    height: 322
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1770 0H1310V322H1770V0Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1504.31 177.035V148.58H1487.21L1482.93 150.838H1466.94V164.84H1457.89V322H1482.93H1512.86V177.035H1504.31Z",
    fill: "url(#paint22_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1310,
    y: 0,
    width: 460,
    height: 322
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1770 0H1310V322H1770V0Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1678.36 304.52L1669.24 118.475H1671.33V116.401H1677.68V102.292H1669.29V100.632H1670.2V96.0679H1671.11V92.7481H1669.29V66.1909H1671.11V62.0412H1669.06V50.1465C1669.06 49.8291 1668.78 49.5715 1668.44 49.5715H1668.16V41.7962C1668.16 41.5409 1668.02 41.3168 1667.81 41.1775V35.9063C1667.81 35.5917 1667.53 35.3364 1667.19 35.3364H1667.02V27.6001H1666.57V35.3364H1666.41C1666.06 35.3364 1665.78 35.5917 1665.78 35.9063V41.1775C1665.57 41.3168 1665.44 41.5409 1665.44 41.7962V49.5715H1665.16C1664.81 49.5715 1664.53 49.8291 1664.53 50.1465V62.0412H1662.49V66.1909H1664.3V92.7481H1662.49V96.0679H1663.4V100.632H1664.3V102.292H1655.91V116.401H1662.26V118.475H1663.99L1655.23 304.52H1678.36Z",
    fill: "url(#paint23_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1310,
    y: 0,
    width: 460,
    height: 322
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1770 0H1310V322H1770V0Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1757.84 189.076V159.997H1768.93L1771.7 162.305H1782.07V176.614H1787.94V318.78H1771.7H1752.3V189.076H1757.84Z",
    fill: "url(#paint24_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1310,
    y: 0,
    width: 460,
    height: 322
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1770 0H1310V322H1770V0Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.7 190.9V212.18L1670.18 214.544V309.12H1720.78V216.908H1715.36V205.086H1709.94V190.9H1674.7Z",
    fill: "url(#paint25_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1310,
    y: 0,
    width: 460,
    height: 322
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1770 0H1310V322H1770V0Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1761.26 206.08V248.86H1742.41V141.197H1739.12V89.3169H1733.35V78.6118H1712.77L1706.18 81.0825V90.9642H1698.77V107.434H1692.18V294.86H1663.28V168.695L1661.06 163.507H1654.39V144.235H1644.75C1626.22 147.2 1618.07 163.507 1618.07 163.507V261.74H1595.31V229.263C1592.66 228.843 1580.89 229.263 1580.89 229.263V223.808C1540.29 217.932 1509.18 226.325 1509.18 226.325V276.46H1476.52V199.695H1471.58V190.679H1466.64V179.86H1434.52V196.089L1430.41 197.892V254.84L1418.94 266.8H1407.06V156.217L1400.16 153.056V146.339L1374.4 143.968L1353.58 147.92V156.217V156.298L1345.88 161.354V275.54H1327.94V192.28L1316.21 179.86H1304.48V322H1324.72H1327.94H1345.88H1362.9H1402.46H1407.06H1430.41H1448.46H1471.92H1476.52H1509.18H1517.46H1595.31H1626.35H1636.6H1666.96H1671.56H1692.18H1722.62H1742.41H1758.04H1778.74H1814.16V194.12H1790.4L1761.26 206.08Z",
    fill: "url(#paint26_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1770,
    y: 0,
    width: 460,
    height: 322
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2230 0H1770V322H2230V0Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1810.46 145.123L1807.01 145.124L1807.01 137.534L1803.33 137.536L1803.32 118.216L1794.77 118.219L1794.77 118.21L1794.42 93.8325L1794.32 87.3999H1795.99V86.9399H1794.32L1794.07 69.4548H1793.15L1792.89 86.9399H1791.39V87.3999H1792.89L1792.79 93.8325L1792.44 118.21L1792.44 118.22L1783.77 118.224L1783.78 137.544L1780.1 137.545L1780.1 145.135L1776.65 145.137L1776.7 322.698L1810.48 322V322.453L1810.51 322.46L1810.46 145.123Z",
    fill: "url(#paint27_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1770,
    y: 0,
    width: 460,
    height: 322
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2230 0H1770V322H2230V0Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1882.7 274.338V152.463L1886.94 143.461V127.88H1922.72V288.88H1882.7V274.338Z",
    fill: "url(#paint28_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1770,
    y: 0,
    width: 460,
    height: 322
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2230 0H1770V322H2230V0Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1964.31 177.035V148.58H1947.21L1942.93 150.838H1926.94V164.84H1917.89V322H1942.93H1972.86V177.035H1964.31Z",
    fill: "url(#paint29_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1770,
    y: 0,
    width: 460,
    height: 322
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2230 0H1770V322H2230V0Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2138.36 304.52L2129.24 118.475H2131.33V116.401H2137.68V102.292H2129.29V100.632H2130.2V96.0679H2131.11V92.7481H2129.29V66.1909H2131.11V62.0412H2129.06V50.1465C2129.06 49.8291 2128.78 49.5715 2128.44 49.5715H2128.16V41.7962C2128.16 41.5409 2128.02 41.3168 2127.81 41.1775V35.9063C2127.81 35.5917 2127.53 35.3364 2127.19 35.3364H2127.02V27.6001H2126.57V35.3364H2126.41C2126.06 35.3364 2125.78 35.5917 2125.78 35.9063V41.1775C2125.57 41.3168 2125.44 41.5409 2125.44 41.7962V49.5715H2125.16C2124.81 49.5715 2124.53 49.8291 2124.53 50.1465V62.0412H2122.49V66.1909H2124.3V92.7481H2122.49V96.0679H2123.4V100.632H2124.3V102.292H2115.91V116.401H2122.26V118.475H2123.99L2115.23 304.52H2138.36Z",
    fill: "url(#paint30_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1770,
    y: 0,
    width: 460,
    height: 322
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2230 0H1770V322H2230V0Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2134.7 190.9V212.18L2130.18 214.544V309.12H2180.78V216.908H2175.36V205.086H2169.94V190.9H2134.7Z",
    fill: "url(#paint31_linear_6806_1377)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_6806_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1770,
    y: 0,
    width: 460,
    height: 322
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2230 0H1770V322H2230V0Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_6806_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2221.26 206.08V248.86H2202.41V141.197H2199.12V89.3169H2193.35V78.6118H2172.77L2166.18 81.0825V90.9642H2158.77V107.434H2152.18V294.86H2123.28V168.695L2121.06 163.507H2114.39V144.235H2104.75C2086.22 147.2 2078.07 163.507 2078.07 163.507V261.74H2055.31V229.263C2052.66 228.843 2040.89 229.263 2040.89 229.263V223.808C2000.29 217.932 1969.18 226.325 1969.18 226.325V276.46H1936.52V199.695H1931.58V190.679H1926.64V179.86H1894.52V196.089L1890.41 197.892V254.84L1878.94 266.8H1867.06V156.217L1860.16 153.056V146.339L1834.4 143.968L1813.58 147.92V156.217V156.298L1805.88 161.354V275.54H1787.94V192.28L1776.21 179.86H1764.48V322H1784.72H1787.94H1805.88H1822.9H1862.46H1867.06H1890.41H1908.46H1931.92H1936.52H1969.18H1977.46H2055.31H2086.35H2096.6H2126.96H2131.56H2152.18H2182.62H2202.41H2218.04H2238.74H2274.16V194.12H2250.4L2221.26 206.08Z",
    fill: "url(#paint32_linear_6806_1377)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6806_1377",
    x1: 62.7102,
    y1: 288.88,
    x2: 62.7102,
    y2: 127.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6806_1377",
    x1: 105.375,
    y1: 322,
    x2: 105.375,
    y2: 148.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6806_1377",
    x1: 286.796,
    y1: 304.52,
    x2: 286.796,
    y2: 27.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6806_1377",
    x1: 390.118,
    y1: 318.78,
    x2: 390.118,
    y2: 159.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6806_1377",
    x1: 315.48,
    y1: 309.12,
    x2: 315.48,
    y2: 190.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6806_1377",
    x1: 179.32,
    y1: 322,
    x2: 179.32,
    y2: 78.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6806_1377",
    x1: 413.58,
    y1: 322.698,
    x2: 413.58,
    y2: 69.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6806_1377",
    x1: 522.71,
    y1: 288.88,
    x2: 522.71,
    y2: 127.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6806_1377",
    x1: 565.375,
    y1: 322,
    x2: 565.375,
    y2: 148.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6806_1377",
    x1: 746.796,
    y1: 304.52,
    x2: 746.796,
    y2: 27.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6806_1377",
    x1: 850.119,
    y1: 318.78,
    x2: 850.119,
    y2: 159.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6806_1377",
    x1: 775.48,
    y1: 309.12,
    x2: 775.48,
    y2: 190.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6806_1377",
    x1: 639.32,
    y1: 322,
    x2: 639.32,
    y2: 78.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6806_1377",
    x1: 873.58,
    y1: 322.698,
    x2: 873.58,
    y2: 69.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6806_1377",
    x1: 982.71,
    y1: 288.88,
    x2: 982.71,
    y2: 127.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6806_1377",
    x1: 1025.37,
    y1: 322,
    x2: 1025.37,
    y2: 148.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6806_1377",
    x1: 1206.8,
    y1: 304.52,
    x2: 1206.8,
    y2: 27.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6806_1377",
    x1: 1310.12,
    y1: 318.78,
    x2: 1310.12,
    y2: 159.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6806_1377",
    x1: 1235.48,
    y1: 309.12,
    x2: 1235.48,
    y2: 190.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6806_1377",
    x1: 1099.32,
    y1: 322,
    x2: 1099.32,
    y2: 78.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6806_1377",
    x1: 1333.58,
    y1: 322.698,
    x2: 1333.58,
    y2: 69.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6806_1377",
    x1: 1442.71,
    y1: 288.88,
    x2: 1442.71,
    y2: 127.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6806_1377",
    x1: 1485.37,
    y1: 322,
    x2: 1485.37,
    y2: 148.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6806_1377",
    x1: 1666.8,
    y1: 304.52,
    x2: 1666.8,
    y2: 27.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6806_1377",
    x1: 1770.12,
    y1: 318.78,
    x2: 1770.12,
    y2: 159.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6806_1377",
    x1: 1695.48,
    y1: 309.12,
    x2: 1695.48,
    y2: 190.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6806_1377",
    x1: 1559.32,
    y1: 322,
    x2: 1559.32,
    y2: 78.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6806_1377",
    x1: 1793.58,
    y1: 322.698,
    x2: 1793.58,
    y2: 69.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6806_1377",
    x1: 1902.71,
    y1: 288.88,
    x2: 1902.71,
    y2: 127.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6806_1377",
    x1: 1945.37,
    y1: 322,
    x2: 1945.37,
    y2: 148.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6806_1377",
    x1: 2126.8,
    y1: 304.52,
    x2: 2126.8,
    y2: 27.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6806_1377",
    x1: 2155.48,
    y1: 309.12,
    x2: 2155.48,
    y2: 190.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6806_1377",
    x1: 2019.32,
    y1: 322,
    x2: 2019.32,
    y2: 78.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.38ecdffcb32bd407c54bfe5faff4eca5.svg";
export { ForwardRef as ReactComponent };